export default "assets/images/footer-logos-d0e2c372.png";